import {gsap} from "gsap";

const getHomeTimeline = (node, delay) => {
  //const timeline = new Timeline({ paused: true });
  const timeline = gsap.timeline({paused: true});
  const name = node.querySelector(".content h1");
  const text = node.querySelector(".content p");
  const socials = node.querySelectorAll(".social span");
  const background = node.querySelector(".homeBackground");

  timeline.from(node, {duration: 0.15, display: "none", autoAlpha: 0, delay: delay })
  timeline.from(name, {duration: 0.55, x: -50, ease:"power3.easeOut", autoAlpha: 0, stagger: 0.125})
  timeline.from(text, {duration: 0.55, x: 50, ease:"power3.easeOut", autoAlpha: 0})
  timeline.from(socials, {duration: 0.55, y: 25, ease:"power3.easeOut", autoAlpha: 0,
    stagger: {
      each: 0.1,
      ease: "power2.easeOut",
    }
  })
  timeline.from(background, {duration: 0.25, display:"none", ease:"power3.easeOut", autoAlpha: 0})

  /*
  timeline
    .from(node, 0.15, { display: "none", autoAlpha: 0, delay })
    .from(name, 0.55, { autoAlpha: 0, x: -25, ease: Power1.easeOut }, 0.125)
    .staggerFrom(text,0.55,{ autoAlpha: 0, x: 25, ease: Power1.easeOut },0.125)
    .staggerFrom(socials,0.55,{ autoAlpha: 0, x: -25, ease: Power1.easeOut }, 0.125);
  */

  return timeline;
};

const getProjectsTimeline = (node, delay) => {
  const timeline = gsap.timeline({ paused: true });
  const text = node.querySelector(".text");
  const nav = node.querySelectorAll(".project-nav");
  const buttons = node.querySelectorAll(".project-nav a");

  timeline.from(node, {duration: 0.15, display: "none", autoAlpha: 0, delay: delay })
  timeline.from(text, {duration: 0.15, ease:"power1.easeInOut", autoAlpha: 0})
  timeline.from(nav, {duration: 0.15, y: 25, ease:"power1.easeInOut", autoAlpha: 0})
  timeline.from(buttons, {duration: 0.15, y: 25, ease:"power1.easeInOut", autoAlpha: 0, stagger: 0.125 })
  
  /*
  timeline
    .from(node, 0.15, {display: "none", autoAlpha: 0, delay})
    .from(text, 0.15, { autoAlpha: 0,ease: Power1.easeInOut})
    .from(nav, 0.15, { autoAlpha: 0, y: 25, ease: Power1.easeInOut})
    .staggerFrom(buttons, 0.250, { autoAlpha: 0, y: 25, ease: Power1.easeInOut}, 0.125);
  */

  return timeline;
};

const getProjectItemTimeline = (node, delay) => {
  const timeline = gsap.timeline({ paused: true });
  //const content = node.querySelectorAll(".project-content");
  const content = node;
  //console.log(content);

  //timeline.from(node, {duration: 0.55, display: "none", autoAlpha: 0,  ease: "power1.easeInOut", delay: delay})
  timeline.from(content, {duration: 0.55, y: 100, display: "none", autoAlpha: 0,  ease: "power1.easeInOut", delay: delay})

  return timeline;
};

const getDefaultTimeline = (node, delay) => {
    const timeline = gsap.timeline({ paused: true });
    const content = node.querySelectorAll(".resume-content h2")

    timeline.from(node, {duration: 0.15, display: "none", autoAlpha: 0, delay: delay})
    timeline.from(content, {duration: 0.25, autoAlpha: 0, ease: "power1.easeInOut", delay: delay});
    
    return timeline;
}

export const play = (pathname, node, appears) => {
  const delay = appears ? 0 : 0.5;
  let timeline;

  // console.log(pathname);
  // console.log(node);
  if (pathname === "/")
    timeline = getHomeTimeline(node, delay);
  else
    if (pathname === "/projects")
        timeline = getProjectsTimeline(node, delay)
    else
      if(pathname.includes("/projects"))
        timeline = getProjectItemTimeline(node)
      else
        timeline = getDefaultTimeline(node, delay)

  timeline.play();
};

export const exit = (node) => {
  const timeline = gsap.timeline({ paused: true });

  timeline.to(node, {duration: 0.15, autoAlpha: 0, ease: "power1.easeOut" });
  timeline.play();
};
